import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';

export const updateIncentiveSocietyData = (
  decodedData: {
    incentiveOffersCount?: { buy: number; sell: number; total: number };
  } | null,
  dispatch: Dispatch
) => {
  if (decodedData?.incentiveOffersCount !== undefined) {
    dispatch({
      type: types.UPDATE_INCENTIVE_OFFERS_COUNT,
      incentiveOffersCount: decodedData.incentiveOffersCount,
    });
  }
};
